<template>
	<div class="PartyConstructionWarp">
		<NavMenu/>
		<el-image :src="img1" class="topimgbox"></el-image>
		<div class="typeArae">
			<div class="contentWarp">
				<div class="primaryTitle">
					<span class="left-line"></span>
					<span class="title">党建引领</span>
					<span class="right-line"></span>
				</div>
				<div>
					<div class="rightMore" @click="gonewsecond1">
						<span class="morebox">
							更多
							<i class="el-icon-caret-right"></i>
						</span>
					</div>
					<div class="newBox1" v-if="newsDataBox.length!=0">

						<div class="leftinfobox" @click="goNewsDetailFn(newsDataBox[0])">
							<div class="textBox">
								<div class="title overflowone">{{newsDataBox[0].pressTopic}}</div>
								<div class="time">{{newsDataBox[0].pressTime | timer}}</div>
								<div class="synopsis overflowthree">{{newsDataBox[0].synopsis}}</div>
							</div>
							<img class="imgbox" :src="srcUrl+newsDataBox[0].titleImgUrl" />
						</div>
						<div class="centerbox" @click="goNewsDetailFn(newsDataBox[1])">
							<img class="imgbox" :src="srcUrl+newsDataBox[1].titleImgUrl" />
							<div class="textBox">
								<div class="title overflowone">{{newsDataBox[1].pressTopic}}</div>
								<div class="time">{{newsDataBox[1].pressTime | timer}}</div>
								<div class="synopsis overflowthree">{{newsDataBox[1].synopsis}}</div>
							</div>
						</div>

					</div>
					<div class="emptyBox" v-else>
						<img src="@/assets/imgs/home/emptyimg.png" />
					</div>
				</div>
				<div class="primaryTitle">
					<span class="left-line"></span>
					<span class="title">党建动态</span>
					<span class="right-line"></span>
				</div>

				<div class="contentDataBox2">
					<div class="rightMore" @click="gonewsecond2">
						<span class="morebox">
							更多
							<i class="el-icon-caret-right"></i>
						</span>
					</div>
					<div class="leftImgRightTextBox" v-if='newsDataBox2.length!=0'>
						<div v-for="(item,index) in newsDataBox2" :key="index" class="itemBox" @click="goNewsDetailFn(item)">
							<img :src="srcUrl+item.titleImgUrl" class="imgbox" />
							<div class="contentbox">
								<div class="title overflowone">{{item.pressTopic}}</div>
								<div class="synopsis overflowthree">{{item.synopsis}}</div>
								<div class="time">{{item.pressTime | timer}}</div>

							</div>
						</div>
					</div>
					<div class="emptyBox" v-else>
						<img src="@/assets/imgs/home/emptyimg.png" />
						
					</div>
				</div>

				<div class="primaryTitle">
					<span class="left-line"></span>
					<span class="title">学习园地</span>
					<span class="right-line"></span>
				</div>
				<div class="newsbox2warp">
					<div class="rightMore" @click="gonewsecond3">
						<span class="morebox">
							更多
							<i class="el-icon-caret-right"></i>
						</span>
					</div>
					<div class="newsbox2" v-if="studyNewsData2.length!==0">
						<div class="leftBox" v-if="studyNewsData2.length!==0" @click="goNewsDetailFn(studyNewsData2[0])">
							<img :src="srcUrl+studyNewsData2[0].titleImgUrl" class="imgbox" />
							<div class="title overflowone">{{studyNewsData2[0].pressTopic}}</div>
							<div class="hoverbox">
								<div class="textBox">
									<!-- <div class="one">{{ studyNewsData2[0].pressTopic }}</div> -->
									<div class="two">{{ studyNewsData2[0].synopsis }}</div>
								</div>
							</div>
						</div>
						<div class="rightBox" v-if="studyNewsData.length!==0">
							<div v-for="(item,index) in  studyNewsData" :key="index" class="studyItemBox" @click="goNewsDetailFn(item)">
								<img :src="srcUrl+studyNewsData[0].titleImgUrl" class="imgbox" />
								<div class="title overflowone">{{studyNewsData[0].pressTopic}}</div>
								<div class="hoverbox">
									<div class="textBox">
										<!-- <div class="one">{{ item.pressTopic }}</div> -->
										<div class="two">{{ item.synopsis }}</div>
									</div>
								</div>
							</div>

						</div>
					</div>
					<div class="emptyBox" v-else>
						<img src="@/assets/imgs/home/emptyimg.png" />
						
					</div>

				</div>

				<div class="primaryTitle">
					<span class="left-line"></span>
					<span class="title">会员党建</span>
					<span class="right-line"></span>
				</div>
				<div class="newsbox3">
					<div class="rightMore" @click="gonewsecond4">
						<span class="morebox">
							更多
							<i class="el-icon-caret-right"></i>
						</span>
					</div>
					<div class="topImgbot4textBox" v-if='memberPartyData.length!==0'>
						<div v-for="(item,index) in memberPartyData" :key="index" class="newsItembox" @click="goNewsDetailFn(item)">
							<img :src="srcUrl+item.titleImgUrl" class="imgbox" />
							<div class="contentbox">
								<div class="title overflowone">{{item.pressTopic}}</div>
								<div class="synopsis overflowthree">{{item.synopsis}}</div>
								<div class="time">{{item.pressTime | timer}}</div>
							</div>
						</div>
					</div>
					<div class="emptyBox" v-else>
						<img src="@/assets/imgs/home/emptyimg.png" />
					</div>

				</div>
			</div>
		</div>
		<div class="footerbox">
			<Footer/>
		</div>
	</div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import { httpService, srcUrl } from "@/service/httpService";
export default {
	components: {
		NavMenu,
		Footer
	},
	data() {
		return {
			srcUrl: srcUrl,
			img1: require("@/assets/imgs/party/img1.png"),
			newsDataBox: [],
			newsDataBox2: [],
			studyNewsData: [],
			studyNewsData2: [],
			memberPartyData: [],
		}
	},
	mounted() {
		this.getnews()
		this.getnews2()
		this.getstudynews()
		this.getmemberPartynews()

	},
	methods: {
		async getnews() {
			let params = {
				pageSize: 2,
				pageCurrent: 1,
				pressSuperClass: 24,
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				this.newsDataBox = data.result.list
			}
		},
		async getnews2() {
			let params = {
				pageSize: 4,
				pageCurrent: 1,
				pressSuperClass: 9,
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				this.newsDataBox2 = data.result.list
			}
		},
		async getstudynews() {
			let params = {
				pageSize: 5,
				pageCurrent: 1,
				pressSuperClass: 14,
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				this.studyNewsData = data.result.list.splice(1);
				this.studyNewsData2 = data.result.list.splice(0, 1);

			}
		},
		async getmemberPartynews() {
			let params = {
				pageSize: 4,
				pageCurrent: 1,
				pressSuperClass: 25,
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				this.memberPartyData = data.result.list;

			}
		},
		gonewsecond1() {
			this.$router.push('/party-secondpage/party-leads');
		},
		gonewsecond2() {
			this.$router.push('/party-secondpage/party-dynamic');
		},
		gonewsecond3() {
			this.$router.push('/party-secondpage/study-section');
		},
		gonewsecond4() {
			this.$router.push('/party-secondpage/party-member');
		},
		goNewsDetailFn(val) {
			this.$router.push({
				path: "/news-detail",
				query: {
					id: val.pressId,
				},
			});
		}
	},
	filters: {
		timer: (value) => {
			return value.substring(0, 10);
		},
	},
}
</script>
<style lang="less" scoped>
.PartyConstructionWarp {
	width: 100%;
	margin: 0 auto;
	.topimgbox {
		width: 100%;
		height: 300px;
	}
	.contentWarp {
		width: 1200px;
		margin: 0 auto;
		.newBox1 {
			width: 1200px;
			margin: 0 auto;
			display: flex;
			flex-direction: row;
			.textBox {
				padding: 113px 45px;
				box-sizing: border-box;
				height: 400px;
				position: relative;
				.title {
					font-size: 18px;
					font-weight: bold;
					line-height: 28px;
					color: #333333;
				}
				.time {
					color: #999999;
					line-height: 36px;
					margin-bottom: 20px;
				}
				.synopsis {
					font-size: 16px;
					font-weight: 400;
					line-height: 30px;
					color: #666666;
				}
			}
			.imgbox {
				width: 672px;
				height: 410px;
			}
			.leftinfobox,
			.centerbox {
				display: flex;
				flex-direction: column;
				width: 672px;
			}
		}
		.contentDataBox2 {
			width: 1200px;
			margin: 0 auto;
			.leftImgRightTextBox {
				.itemBox {
					margin: 0 0 40px 0;
					width: 100%;
					cursor: pointer;
					.imgbox {
						width: 301px;
						height: 152px;
					}
					.contentbox {
						width: 77%;
						.time {
							margin-top: 0;
						}
					}
				}
			}
		}
		.newsbox2warp {
			.newsbox2 {
				display: flex;
				flex-direction: row;
				.leftBox {
					width: 620px;
					height: 410px;
					position: relative;
					cursor: pointer;
					.title {
						position: absolute;
						bottom: 0;
						background: rgba(0, 0, 0, 0.39);
						width: 100%;
						font-size: 22px;
						line-height: 30px;
						color: #ffffff;
						text-align: center;
						padding: 0 10px;
						box-sizing: border-box;
					}
					&:hover {
						.hoverbox {
							height: 410px;
						}
					}
					.imgbox {
						width: 100%;
						height: 100%;
					}
				}
				.hoverbox {
					width: 100%;
					height: 0;
					overflow: hidden;
					position: absolute;
					top: 0;
					left: 0;
					background: #61aff7;
					color: #fff;
					transition: all 1s;
					.textBox {
						line-height: 32px;
						text-align: justify;
						padding: 0 20px;
						margin-top: 90px;
						.one {
							font-size: 18px;
							font-weight: 500;
						}
						.two {
							font-size: 16px;
							line-height: 30px;
						}
					}
				}
				.rightBox {
					width: 700px;
					display: flex;
					flex-direction: row;
					flex-wrap: wrap;
					.studyItemBox {
						width: 288px;
						height: 193px;
						margin: 0 0 24px 30px;
						position: relative;
						cursor: pointer;
						&:nth-child(3),
						&:nth-child(4) {
							margin-bottom: 0;
						}
						.title {
							position: absolute;
							bottom: 0;
							background: rgba(0, 0, 0, 0.39);
							width: 100%;
							font-size: 22px;
							line-height: 30px;
							color: #ffffff;
							text-align: center;
							padding: 0 10px;
							box-sizing: border-box;
						}
						&:hover {
							.hoverbox {
								height: 193px;
							}
						}
						.imgbox {
							width: 100%;
							height: 100%;
						}
					}
				}
			}
		}
		.newsbox3 {
			width: 1200px;
			margin: 0 auto;
			.topImgbot4textBox {
				.newsItembox {
					cursor: pointer;
				}
				.imgbox {
					height: 223px;
				}
				.contentbox {
					min-height: 197px;
					.title {
						margin-bottom: 10px;
					}
				}
			}
		}
	}
	.footerbox {
		margin-top: 60px;
	}
}
</style>




